<template>
  <div class="pickUp">
    <div class="listContent area1"> 

      <div class="content">
        <div class="top clear">
          <div class="l">
            <div class="marBot20">
              <i class="fa fa-finish" style="font-size:26px;color:#1aad19"></i>
              <span class="Info font16 verMid"  >Submitted successfully，Total cost：<span class="colRed">US ${{Number(takeNumInfo.ordNumCost).toFixed(2)}}</span> </span>
            </div>
            <div style="padding-left:33px;padding-bottom:10px" >
              <div v-for="(item,index) in takeNumInfo.list" :key="index" class="THorder marBot10">
                <span class="marL20 colBlack">Bill of lading ({{index+1}}):</span>
                <span class="colBlue marL20 cursor" @click="goDetail(item.THBillNo)">{{item.THBillNo}}</span>
                <a class="lineBlueBtnW marL20 cursor" @click="goEdit(item.THBillNo)">Edit bill of lading</a>
              </div>
            </div>
          </div>
          <ul class="r marR20">
            <li>
              <a class="s-blueBtn" @click="clkMake">Recharge</a>
            </li>
          </ul>
        </div>
        <div class="line"></div>
        <div class="bot">
          <div>
            <div>
              <div class="serialNum">1</div>
              <span class="Info">Remark:</span>
            </div>
            <div style="padding:0 41px 0 32px;">
              Please carefully check the quantity of delivered goods and check the pick-up list number. For goods with different pick-up lists, please pack them separately and intensively, and mark them (attach address labels respectively) to inform the receiver. Avoid the loss caused by the confusion of goods at different addresses; when picking up the goods, the pick-up must ask the pick-up to give a receipt indicating the number of actually received pieces.
            </div>
          </div>
          <div class="marBot20 marTop10">
            <div class="serialNum">2</div>
            <span class="Info" style="display:inline-block">I would like to inform my supplier to prepare the goods.</span>
            <a class="lineBlueBtnW marL20" style="width:auto;padding:0 20px"  @click="noticeSupplierBtn = true"> Notify my supplier</a>
          </div>
          <div>
            <div class="serialNum">3</div>
            <span class="Info" style="display:inline-block">I would like to inform my exclusive salesman.</span>
            <a class="lineBlueBtnW marL20" style="width:auto;padding:0 20px"  @click="noticeSalesBtn = true"> Notify my exclusive salesman</a>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Notify my supplier" :visible.sync="noticeSupplierBtn" :close-on-click-modal="false" custom-class="addOrd discernBox" width="420px">
      <div class="content" style="margin:0 25px;"> 
        <div class="left"></div>
        <div class="marTop10  ">
          <span >&emsp;&emsp;&emsp;&emsp;</span>
           Freightshop will notify your supplier via email.
        </div >
        <div class="clear marTop10">
          <span class="fontWeight colBlack">Email：</span>
          <el-input  style="width:250px" :class="(EmailTip && !Email)?'inputWarn':''" maxlength="500" @blur="EmailBlur"  v-model="Email"></el-input>
        </div>
        <div class="foot">
          <div class="btn marTop10">
            <div class="lineBlueBtnW cursor" style="width:auto;padding:0 20px" @click="noticeSupplierBtn = false">Cancel</div>
            <div class="blueBtnW marL10 cursor"  style="width:auto;padding:0 20px" @click="noticeSupplier">Send notification</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="Notify my exclusive salesman" :visible.sync="noticeSalesBtn" :close-on-click-modal="false" custom-class="addOrd discernBox" width="420px">
      <div class="content fontWeight marTop10 colBlack">
        <div style="text-align:center">
          <div>
            Freightshop will notify your exclusive salesman via email.
          </div>
          <div>
            Do you want to send a notification？
          </div>
        </div>
        <div class="foot marTop20">
          <div class="btn">
            <div class="lineBlueBtnW cursor"  style="width:auto;padding:0 20px" @click="noticeSalesBtn = false">Cancel</div>
            <div class="blueBtnW cursor"  style="width:auto;padding:0 20px"   @click="noticeSales">Send notification</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { post, fetch, Del, put } from "@/ask/axios";
export default {
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: ""
      },
      THBillNo:'',
      sendTh:'',
      Email:'',
      EmailTip:false,
      takeNumInfo:'',
      ordNumCost:'',
      noticeSupplierBtn:false,
      noticeSalesBtn:false,
    }
  },
  created() {

    this.ordNumCost = this.$route.query.ordNumCost
  //获取取件单号
    this.takeNumInfo = JSON.parse(sessionStorage.getItem('urlList'))
    let sendTh = [] 
    this.takeNumInfo.list.forEach(element => {
      sendTh.push(element.THBillNo)
    });
    this.sendTh = sendTh.join(",")
  },
  methods: {
    //点击立即充值
    clkMake(){
      window.location.href='/payment/myPayment?ordCost='+Number(this.takeNumInfo.ordNumCost).toFixed(2)
    },
    goEdit(THBillNo) {
      this.$router.push({path:'/pickUp/pickUpEdit',query:{thNo:THBillNo,}});
    },
    goDetail(THBillNo) {
      this.$router.push({path:'/pickup/pickupDetails',query:{thNo:THBillNo,}});
    },
    noticeSales() {
      this.api.url = this.$api03 + '/api/TradeCustomer/Email/EmailToSales'
      this.api.param = {
        "PickNumber": this.sendTh,
        "Version": 2
      }
      post(this.api.url, this.api.param).then(res => {
        this.noticeSalesBtn = false
        if(res.IsOK) {
          this.$alert( "successfully",'',  {
            customClass:'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
            center: true
            }).then(() => {
              this.loading = true
            }).catch(() => {
              this.loading = true
          })
        } else {
          this.$alert( "fail",'',  {
            customClass:'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
            center: true
            }).then(() => {
              this.loading = true
            }).catch(() => {
              this.loading = true
          })
        }
      })
    },
    EmailBlur() {
      var emailReg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!emailReg.test(this.Email)) {
        this.Email = ''
      }
    },
    noticeSupplier() {
      this.EmailTip = true
      if(!this.Email) {
        return false
      }
      this.api.url = this.$api03 + '/api/TradeCustomer/Email/EmailToSupplier'
      this.api.param = {
        "Email": this.Email,
        "PickNumber": this.sendTh,
        "Version": 2
      }
      post(this.api.url, this.api.param).then(res => {
        this.noticeSupplierBtn = false
        if(res.IsOK) {
          this.$alert( "successfully",'',  {
            customClass:'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
            center: true
            }).then(() => {
              this.loading = true
            }).catch(() => {
              this.loading = true
          })
        } else {
          this.$alert( "fail",'',  {
            customClass:'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
            center: true
            }).then(() => {
              this.loading = true
            }).catch(() => {
              this.loading = true
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .discernBox{
    .content{
      padding: 10px 20px !important;
      font-size: 12px;
      line-height: 30px;
    }
  }
    // 遮罩层
  .addOrd{
    border-radius: 5px;
    overflow: hidden;
    .el-dialog__header{
      font-size: 12px;
      background: #efefef;
      padding: 10px 20px 10px;
      .el-dialog__title{
        line-height: 12px;
        font-size: 12px;
      }
      .el-dialog__headerbtn{
        top: 12px;
      }
    }
    .el-dialog__body{
      padding: 0;
      .content{
        padding: 30px 20px 0 20px;
        max-height: 300px;
      }
      .foot{
        text-align: center;
        .btn{
          width: 300px;
          margin: auto;
          padding: 10px 0;
        }
      }
    }
  }
</style>
<style lang="scss" scoped>
  @import "../../../assets/css/userCenterCss.css";

  .pickUp{
    min-width: 1100px;
    font-size: 12px;
    line-height: 1.5;
    .area1{
      margin-top: 12px;
      .content{
        padding: 23px 0 25px 0;
        .top{
          padding-left: 33px;
        }
        .bot{
          padding-left: 33px;
        }
        .lineBlueBtnW{
          width: 140px;
        }
      }
    }
    .listContent{
      .header{
        height: 50px;
        background: #f9f9f9;
        border-radius: 10px 10px 0 0;
        line-height: 50px;
        .header-content{
          line-height: 50px;
        }
      }
      .leftInfo{
        width: 133px;
        text-align: right;
        font-weight: bold;
        color: black;
      }
      .content{
        .goodsName{
          .dataInput{
            width: 80%;
          }
        }
        .grayBtnW{
          min-width: 220px;
          height: 30px;
          line-height: 30px;
          margin: 0 20px 15px 0;
        }
      }
    }
  }

  .Info{
    font-weight: bold;
    color: black;
  }
  .serialNum{
    margin-right: 5px;
    display: inline-block;
    width: 24px;
    height: 24px;
    text-align: center;
    background: #f2f2f2;
    border-radius:24px;
    line-height: 24px;
    color: #9c9c9c; 
  }
  .line{
    margin: 23px 0 20px 0 ;
    height: 3px;
    border: none;
    background-color: #ddd;
    background-image: repeating-linear-gradient(-45deg, #fff, #fff 4px, transparent 4px, transparent 8px);
  }
  .s-blueBtn{border: 1px solid #004FB1;  border-radius: 30px;  background: #004FB1;  color: #fff !important;  width: 98px;  height: 28px; display: block; text-align: center; line-height: 28px;}

</style>


// WEBPACK FOOTER //
// src/components/userCenter/pickUp/pickUpSuccess.vue